import { useRule } from "../CreateRuleNew/RuleReducer";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import Button3 from "../../../Button/Button3";
import classes from "./RuleWizard.module.css";
import { Dialog } from "primereact/dialog";
import ChooseUsers from "./WizardStepChooseUsers";
import { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { useSelector } from "react-redux";

const RECIPIENT_OPTIONS = [
    // { value: "", label: "All users", description: "Notify everyone that has access to this site" },
    { value: "JUST_ME", label: "Just me", description: "Only notify me" },
    { value: "ALL_MANAGERS", label: "All managers", description: "Notify only those with manager access" },
    { value: "ALL_STANDARD_USERS", label: "All standard users", description: "Notify only those with standard user level access" },
    { value: "SELECTED_USERS", label: "Specific users", description: "Notify specific users only. Click to select users" },
];

const LEVEL_OPTIONS = [
    { value: "STANDARD", label: "Standard" },
    { value: "CRITICAL", label: "High priority" },
];

const SUB_STEPS = [
    { title: "Who should be notified?", subtitle: "Choose who receives this alert." },
    { title: "Alert priority", subtitle: "Set the urgency level of this alert." },
    { title: "Alert message", subtitle: "Add a custom message to the alert." },
];

const WizardStepAlert = ({ onNext, onBack }) => {
    const { state, dispatch } = useRule();
    const userID = useSelector(s => s.auth.userID);
    const [subStep, setSubStep] = useState(0);
    const [showSelectUsersPopup, setShowSelectUsersPopup] = useState(false);

    const alertAction = state.actions.find(a => a.action_type === "SEND_ALERT");
    const recipientType = alertAction?.alert_recipient_type ?? null;
    const alertLevel = alertAction?.alert_level ?? "";
    const isCritical = alertAction?.critical_notification ?? false;
    const isStandard = alertAction?.alert_level == "STANDARD"

    const updateAlert = (updates) => {
        const isChangingRecipient = "alert_recipient_type" in updates;
        const switchingAwayFromSelectedUsers = isChangingRecipient && updates.alert_recipient_type !== "SELECTED_USERS";

        dispatch({
            type: "SET_ADV_RULE_ACTION",
            payload: state.actions.map(a => {
                if (a.action_type !== "SEND_ALERT") return a;
                const next = { ...a, ...updates };
                if (updates.alert_recipient_type === "JUST_ME") {
                    next.target_users = [userID];
                } else if (switchingAwayFromSelectedUsers) {
                    delete next.target_users;
                }
                return next;
            }),
        });

        if (updates.alert_recipient_type === "SELECTED_USERS") {
            setShowSelectUsersPopup(true);
        }
    };

    const handleUsersConfirmed = (selectedUserIds) => {
        dispatch({
            type: "SET_ADV_RULE_ACTION",
            payload: state.actions.map(a =>
                a.action_type === "SEND_ALERT" ? { ...a, target_users: selectedUserIds } : a
            ),
        });
        setShowSelectUsersPopup(false);
    };

    const handleNext = () => subStep < 2 ? setSubStep(s => s + 1) : onNext();
    const handleBack = () => subStep > 0 ? setSubStep(s => s - 1) : onBack();

    const canAdvanceFromRecipients = recipientType !== null;

    return (
        <>
            <Dialog
                header="Select users"
                visible={showSelectUsersPopup}
                style={{ width: "35vw" }}
                onHide={() => setShowSelectUsersPopup(false)}
            >
                <ChooseUsers setShowChooseUsers={setShowSelectUsersPopup} onConfirm={handleUsersConfirmed} />
            </Dialog>

            <div className={classes.contentHeader}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "4px" }}>
                    <h2 className={classes.contentTitle} style={{ margin: 0 }}>{SUB_STEPS[subStep].title}</h2>
                    <div style={{ display: "flex", gap: "6px" }}>
                        {SUB_STEPS.map((_, i) => (
                            <div
                                key={i}
                                style={{
                                    width: "8px", height: "8px", borderRadius: "50%",
                                    background: i === subStep ? "var(--Primary-Color)" : i < subStep ? "#4caf50" : "#d0d0d0",
                                    transition: "background 0.2s",
                                }}
                            />
                        ))}
                    </div>
                </div>
                <p className={classes.contentSubtitle}>{SUB_STEPS[subStep].subtitle}</p>
            </div>

            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "10px" }}>

                {/* Sub-step 0: Recipients */}
                {subStep === 0 && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {RECIPIENT_OPTIONS.map(opt => (
                            <div
                                key={opt.value}
                                style={{
                                    display: "flex", alignItems: "center", gap: "12px",
                                    padding: "12px 16px",
                                    border: `2px solid ${recipientType === opt.value ? "var(--Primary-Color)" : "#e0e0e0"}`,
                                    borderRadius: "8px", cursor: "pointer",
                                }}
                                onClick={() => updateAlert({ alert_recipient_type: opt.value })}
                            >
                                <div style={{
                                    width: "16px", height: "16px", borderRadius: "50%", flexShrink: 0,
                                    border: `2px solid ${recipientType === opt.value ? "var(--Primary-Color)" : "#ccc"}`,
                                    background: recipientType === opt.value ? "var(--Primary-Color)" : "white",
                                }} />
                                <div>
                                    <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#2d2d2d" }}>{opt.label}</p>
                                    <p style={{ margin: 0, fontSize: "12px", color: "#9e9e9e" }}>{opt.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Sub-step 1: Priority */}
                {subStep === 1 && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                        {/* <div>
                            <p style={{ margin: "0 0 8px 0", fontSize: "13px", color: "#6e6e6e", fontWeight: 600 }}>Alert level:</p>
                            <div style={{ display: "flex", gap: "8px" }}>
                                {LEVEL_OPTIONS.map(opt => (
                                    <Button3
                                        key={opt.value}
                                        style={{
                                            minWidth: "130px", minHeight: "36px", fontSize: "13px",
                                            backgroundColor: alertLevel === opt.value ? "var(--Primary-Color)" : undefined,
                                            color: alertLevel === opt.value ? "white" : undefined,
                                            border: alertLevel === opt.value ? "2px solid lightblue" : undefined,
                                        }}
                                        onClick={() => updateAlert({ alert_level: opt.value })}
                                    >
                                        {opt.label}
                                    </Button3>
                                ))}
                            </div>
                        </div> */}

                        

                        {/* <Divider style={{ margin: 0 }} /> */}

                        <div
                            style={{
                                display: "flex", alignItems: "center", gap: "14px", padding: "14px 16px",
                                border: `2px solid ${isStandard ? "var(--Primary-Color)" : "#e0e0e0"}`,
                                borderRadius: "8px", cursor: "pointer",
                            }}
                            onClick={() => updateAlert({ alert_level:  "STANDARD"})}
                        >
                            <div style={{
                                width: "18px", height: "18px", borderRadius: "4px", flexShrink: 0,
                                border: `2px solid ${isStandard ? "var(--Primary-Color)" : "#ccc"}`,
                                background: isStandard ? "var(--Primary-Color)" : "white",
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                                {isStandard && <span style={{ color: "white", fontSize: "11px", fontWeight: 700, lineHeight: 1 }}>✓</span>}
                            </div>
                            <div>
                                <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#2d2d2d" }}>Standard notification</p>
                                <p style={{ margin: 0, fontSize: "12px", color: "#9e9e9e" }}>Delivers as a standard push notification with sound</p>
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex", alignItems: "center", gap: "14px", padding: "14px 16px",
                                border: `2px solid ${isCritical ? "var(--Primary-Color)" : "#e0e0e0"}`,
                                borderRadius: "8px", cursor: "pointer",
                            }}
                            onClick={() => updateAlert({ critical_notification: !isCritical })}
                        >
                            <div style={{
                                width: "18px", height: "18px", borderRadius: "4px", flexShrink: 0,
                                border: `2px solid ${isCritical ? "var(--Primary-Color)" : "#ccc"}`,
                                background: isCritical ? "var(--Primary-Color)" : "white",
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                                {isCritical && <span style={{ color: "white", fontSize: "11px", fontWeight: 700, lineHeight: 1 }}>✓</span>}
                            </div>
                            <div>
                                <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#2d2d2d" }}>Critical notification</p>
                                <p style={{ margin: 0, fontSize: "12px", color: "#9e9e9e" }}>Delivers as a priority push notification with sound</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Sub-step 2: Message */}
                {subStep === 2 && (
                    <InputTextarea
                        value={alertAction?.alert_text ?? ""}
                        onChange={e => updateAlert({ alert_text: e.target.value })}
                        rows={6}
                        placeholder="Enter the message this alert will show to users"
                        style={{ width: "100%" }}
                    />
                )}
            </div>

            <div className={classes.navRow}>
                <Button label="Back" icon="pi pi-arrow-left" severity="secondary" outlined onClick={handleBack} />
                <Button
                    label={subStep === 2 ? "Next" : "Next"}
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    severity="success"
                    disabled={
                        (subStep === 0 && !canAdvanceFromRecipients) ||
                        (subStep === 2 && !alertAction?.alert_text?.trim())
                    }
                    onClick={handleNext}
                />
            </div>
        </>
    );
};

export default WizardStepAlert;
